// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__magnatText_b69a5c', '__magnatText_Fallback_b69a5c'"},"className":"__className_b69a5c","variable":"__variable_b69a5c"};